import { useQuery } from '@tanstack/react-query';

import { getCatalogItems } from 'api/jalapeno';
import assortmentPreviewModuleData from 'shared/AssortmentPreviewModule/assortmentPreviewModuleData';

export const CATALOG_ITEMS_MODULE_QUERY_KEY = 'catalog-items-module';

const useCatalogItemsModuleQuery = () => {
    const externalSkus = [];
    assortmentPreviewModuleData?.forEach((aisle) => {
        externalSkus.push(...aisle.externalSkus.slice(0, 6));
    });

    const query = useQuery({
        queryKey: [CATALOG_ITEMS_MODULE_QUERY_KEY],
        queryFn: async () => {
            const response = await getCatalogItems({ externalSkus });

            response?.data?.items?.forEach((item) => {
                assortmentPreviewModuleData?.forEach((aisle) => {
                    const newAisle = aisle;
                    const itemIndex = aisle?.externalSkus.findIndex((sku) => sku === item.externalSku);
                    if (itemIndex > -1) newAisle.items[itemIndex] = item;
                    return newAisle;
                });
            });

            return { items: assortmentPreviewModuleData };
        },
    });

    return query;
};

export default useCatalogItemsModuleQuery;
